"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var replacer = function replacer(match, negativeSign, number) {
  return "".concat(negativeSign, "0").concat(number);
};
var fillMissedLeadingZero = {
  test: function test(source) {
    return /^-?\.\d*$/.test(source);
  },
  processNumber: function processNumber(_ref) {
    var source = _ref.source,
      caret = _ref.caret;
    var _ref2 = caret,
      start = _ref2.start,
      end = _ref2.end;
    return {
      source: source.replace(/^(-?)(\.\d*)$/, replacer),
      caret: {
        start: start + 1,
        end: end + 1
      }
    };
  }
};
var _default = exports["default"] = fillMissedLeadingZero;